// extracted by mini-css-extract-plugin
export default {"absolute":"loader_absolute__8cuju","normal":"loader_normal__tvo8W"};